<template>
    <div class="control">
        <ul class="box">
            <li>
                <a class="width60 shopCar" href="https://market.digiwincloud.com/dw-display/login?returnUrl=%2Fdw-display%2Fdw-product-details%3FgoodsCode%3DChartReport%26sellingStrategyCode%3D70328781193792" target="_blank" @click="toDwCloudMarket"></a>
            </li>
            <li>
                <!-- <a class="width60 code" href="javascript:;" v-on:mouseenter="isCode=true" v-on:mouseleave="isCode=false"></a> -->
                <a class="width60" href="javascript:;" v-on:mouseenter="isCode=true" v-on:mouseleave="isCode=false" style="line-height:60px;">LINE</a>
                <div v-show="isCode" class="item">
                    <img src="@/assets/img/LINE_fixed.png" alt="" width="100">
                </div>
            </li>
            <li>
                <a class="width60 phone" href="javascript:;" v-on:mouseenter="isPhone=true" v-on:mouseleave="isPhone=false"></a>
                <div v-show="isPhone" id="phone" class="item padding20">04-23054567 轉 分機號4116</div>
            </li>
        </ul>
    </div>
</template>
<script>
  export default {
    name: 'Control',
    data(){
        return {
            isCode: false,
            isPhone: false
        }
    },
    methods: {
        toDwCloudMarket() {//跳转云市场次数埋点
            this.$http.post('/backend/web/record', {
                pageName: 'dwCloudMarket',
                contentName : ''
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/common/Control.vue